import React from 'react';
import './Community.css'
const Community = () => {
    return (
        <div className='container text-white community'>
            
            <div className='community-part'>
                <h1>200</h1>
                <h3>Doctors</h3>
            </div>
            <div className='community-part'>
                <h1>25000+</h1>
                <h3>Happy Patients</h3>
            </div>
            <div className='community-part'>
                <h1>250</h1>
                <h3>Medical Beds</h3>
            </div>
            <div className='community-part'>
                <h1>100</h1>
                <h3>Award </h3>
            </div>
        </div>
    );
};

export default Community;